import { CalendarProps } from 'primereact/calendar';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormErrorMessage from '../../messages/FormErrorMessage';
import CalendarStyled from './../StyledInputs/CalendarStyled';
import { getFieldArrayError } from '@/src/utils/formUtils';

type FormControlledCalendarProps = CalendarProps & {
  defaultValue?: string | Date;
  formID: string;
  rules?: object;
  triggerOnChange?: boolean;
  isFieldArray?: boolean;
  onAdditionalChange?: () => void;
};

const FormControlledCalendar = ({
  defaultValue,
  formID,
  rules,
  triggerOnChange,
  isFieldArray,
  onAdditionalChange,
  ...otherProps
}: FormControlledCalendarProps) => {
  const {
    control,
    formState: { errors },
    trigger,
  } = useFormContext();

  let fieldError = errors[formID];
  if (isFieldArray) {
    fieldError = getFieldArrayError(formID, errors);
  }

  return (
    <React.Fragment>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={formID}
        rules={rules}
        render={({ field: { onChange, ...otherFields } }) => (
          <CalendarStyled
            error={!!fieldError}
            onChange={(e) => {
              onChange(e);
              if (triggerOnChange) {
                trigger(formID);
              }

              if (onAdditionalChange) {
                onAdditionalChange();
              }
            }}
            {...otherProps}
            {...otherFields}
          />
        )}
      />
      {fieldError && (
        <FormErrorMessage errorMessage={fieldError.message as string} />
      )}
    </React.Fragment>
  );
};

export default FormControlledCalendar;
